import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import UsefulTools from '@/components/useful-tools/UsefulTools';

const UsefulToolsPage: React.FC = () => {
  return (
    <MainLayout>
      <UsefulTools />
    </MainLayout>
  );
};

export default UsefulToolsPage;
